import { BookSearchUI, ResponseInfoType } from '../../types';
import { normalizeLegacyBook } from './BookSearchResult';

const BOOK_SOURCE_TYPES = new Set(['book_cover', 'library_holding']);

/** info.ui.type 또는 legacy library_books / book_cover → book_search UI */
export function getBookSearchUI(info?: ResponseInfoType): BookSearchUI | null {
  if (!info) return null;
  const ui = info.ui;
  if (ui && ui.type === 'book_search' && Array.isArray((ui as BookSearchUI).books)) {
    return ui as BookSearchUI;
  }
  const legacy = info.library_books;
  if (Array.isArray(legacy) && legacy.length > 0) {
    return {
      type: 'book_search',
      content: '',
      mode: info.library_ui_mode === 'holdings' ? 'holdings' : 'books',
      books: legacy.map((b, i) => normalizeLegacyBook(b, i)),
      after_content: info.library_after_books || '',
    };
  }
  const sources = info.rich_sources;
  if (
    Array.isArray(sources) &&
    sources.length > 0 &&
    sources.every((s) => BOOK_SOURCE_TYPES.has(String(s?.type || '')))
  ) {
    const isHoldings =
      info.library_ui_mode === 'holdings' ||
      sources.every((s) => s?.type === 'library_holding');
    return {
      type: 'book_search',
      content: '',
      mode: isHoldings ? 'holdings' : 'books',
      books: sources.map((b, i) => normalizeLegacyBook(b, i)),
      after_content: info.library_after_books || '',
    };
  }
  return null;
}
